import { render, staticRenderFns } from "./ImIcon.vue?vue&type=template&id=12361a26&"
import script from "./ImIcon.vue?vue&type=script&lang=js&"
export * from "./ImIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports